module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-portal-users-container"
  }, [_c('div', [_c('admin-view-users-filters', {
    on: {
      "parlay-users-filter-changed": _vm.resetFilters,
      "filters": _vm.searchAndFilters
    }
  })], 1), _vm._v(" "), _c('div', [_c('admin-view-users-table', {
    attrs: {
      "loading": _vm.loading,
      "usersList": _vm.usersList
    },
    on: {
      "scroll-on-table": function($event) {
        return _vm.handleScroll(_vm.page_number)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row w-100 center-xs"
  }, [(_vm.loading_table_body) ? _c('div', [_c('pl-spinner', {
    staticClass: "x5"
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-79204e3e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalParlay/adminPortalParlayUsers/adminViewUsers.vue
// module id = 2189
// module chunks = 61